<template>
  <section>
    <b-row>
      <b-col md="12" class="text-left">
        <h4 class="font-weight-bold">
          {{ $t("match-full-fit-hello") }} {{ firstname }},
        </h4>
        <h4 v-if="name === 'you'" class="font-weight-bold">
          {{ $t("match-full-fit-your-perfect-size-is") }}:
        </h4>
        <h4 v-else class="font-weight-bold">
          {{ $t("match-full-fit-perfect-size-for-user", { name: name }) }}:
        </h4>
      </b-col>
    </b-row>
    <transition name="zoom" :duration="2500" @after-enter="showContent = true">
      <b-row v-if="showAnim" class="justify-content-start">
        <b-col md="12" class="col">
          <b-card class="bg-light-gray mt-3 px-md-5 border-0 text-center ">
            <b-card-body>
              <h1 class="font-weight-bold">
                {{ $t("match-full-fit-size") }} {{ matchSize }}
              </h1>
              <p class="text-dark-gray m-0">{{ productName }}</p>
            </b-card-body>
            <b-card-footer class="bg-light-gray border-0" style="padding: 20px">
              <div v-if="inStock">
                <b-button
                  variant="black"
                  class="shadow-none rounded"
                  @click="addProduct"
                >
                  {{ $t("add-to-cart") }}
                </b-button>
              </div>
              <div v-else>
                <p id="tailieSizeSmall" class="text-center">
                  {{ $t("match-full-fit-no-stock") }}
                </p>
              </div>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

require("vue2-animate/dist/vue2-animate.min.css");

export default {
  name: "components-match-full-fit",
  data() {
    return {
      showAnim: false,
      showContent: false
    };
  },
  created() {
    this.$store.commit(
      "ui/SET_POST_LOADING_TEXT",
      this.$t("match-loading-size-found")
    );
    this.$store.commit("ui/SET_POST_LOADING_ANIMATION_SIZE_FOUND");
  },
  mounted() {
    this.showAnim = true;
  },
  computed: {
    ...mapGetters({
      matchSize: "users/getSelfMatchSize",
      productName: "pageParams/getProductName",
      productColor: "pageParams/getProductColor",
      desiredQuantity: "pageParams/getDesiredQuantity",
      productCombinations: "pageParams/getProductCombinations",
      name: "application/getMatchableName",
      firstname: "users/getSelfFirstName"
    }),
    inStock() {
      let stock = this.productCombinations.find(c => {
        let colorcheck = this.productColor
          ? c.color.toLowerCase() === this.productColor.toLowerCase()
          : true;
        return (
          c.size.toLowerCase() === this.matchSize.toLowerCase() &&
          c.quantity >= this.desiredQuantity &&
          colorcheck
        );
      });
      if (typeof stock == "undefined") return false;
      return stock.quantity > 0;
    }
  },
  methods: {
    addProduct() {
      let variant = this.productCombinations.find(c => {
        let colorcheck = this.productColor
          ? c.color.toLowerCase() === this.productColor.toLowerCase()
          : true;
        return (
          c.size.toLowerCase() === this.matchSize.toLowerCase() && colorcheck
        );
      });
      let item = {
        size: this.matchSize,
        quantity: this.desiredQuantity,
        variant: variant.id
      };
      this.$store.dispatch("application/addCartLog", {
        root: true
      });

      this.$store.dispatch("opener/postMessage", {
        event: "addProduct",
        message: {
          size: [item]
        }
      });
      this.$store.dispatch("application/close");
    }
  }
};
</script>

<style>
#tailie-size #tailie-text-space {
  height: 60px;
}
</style>
